import { createFileRoute, Outlet } from '@tanstack/react-router'
import { PlanningCollaborator } from '~/components/routes/hr/planning/collaborators'
import { HrSlotPortal } from '~/components/routes/hr/planning/hr-toolbar-slot'
import { HrStoreSelector } from '~/components/routes/hr/planning/hr-store-selector'
import { STAFF_READ } from '~/components/routes/hr/tabs'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/hr/planning/collaborators')({
  staticData: {
    permission: STAFF_READ,
  },
  component: RouteComponent,
})
withRoutePermissions(Route)

function RouteComponent() {
  return (
    <>
      <HrSlotPortal name="toolbar">
        <HrStoreSelector asCta={false} />
      </HrSlotPortal>
      <PlanningCollaborator />
      {/* Panneau latéral d'édition (route imbriquée /hr/planning/collaborators/$collaboratorId). */}
      <Outlet />
    </>
  )
}
